var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 147,
    height: 172.497,
    viewBox: "0 0 147 172.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_175",
    x: 0,
    y: 25.497,
    width: 147,
    height: 147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 66.744,
    height: 67.004,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(-341.5 -3329.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(0 770.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M361.162,128.6l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668a3.476,3.476,0,0,0-1.163-1.557Z",
    transform: "translate(81.31 2448.929)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M735.046,77.5l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,735.046,77.5Z",
    transform: "translate(-319.479 2492.157)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(-564.132 180.631) rotate(-17)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 11.168,
    cy: 22.788,
    rx: 11.168,
    ry: 22.788,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M549.9,218.79c4.473-26.838.045-53.578,0-53.845l-.87.147c.045.265,4.448,26.866,0,53.553Z",
    transform: "translate(-365.109 2387.603)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 0.883,
    height: 11.453,
    transform: "translate(175.569 2564.97) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 11.454,
    height: 0.883,
    transform: "translate(186.229 2572.303) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(696.433 34.469) rotate(11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8-2",
    "data-name": "Ellipse 8",
    cx: 9.109,
    cy: 18.587,
    rx: 9.109,
    ry: 18.587,
    transform: "translate(174.65 2546.304)",
    fill: "#5d45ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853-2",
    "data-name": "Path 853",
    d: "M549.735,208.862c3.648-21.889.037-43.7,0-43.917l-.71.12c.037.217,3.628,21.912,0,43.679Z",
    transform: "translate(-366.818 2386.452)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182-2",
    "data-name": "Rectangle 182",
    width: 0.72,
    height: 9.342,
    transform: "translate(175.399 2561.529) rotate(-61.858)",
    fill: "#f8e602"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183-2",
    "data-name": "Rectangle 183",
    width: 9.342,
    height: 0.72,
    transform: "translate(184.094 2567.51) rotate(-28.158)",
    fill: "#f8e602"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M663.565,209.25l2.3-1.836a2.433,2.433,0,0,0-2.816,1.546,3.911,3.911,0,0,0-2.91.18l4.593,1.668A3.476,3.476,0,0,0,663.565,209.25Z",
    transform: "translate(-242.272 2375.306)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 341.5, 3329)",
    filter: "url(#Rectangle_175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175-2",
    "data-name": "Rectangle 175",
    width: 114,
    height: 114,
    rx: 5,
    transform: "translate(16.5 39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(384.865 3391.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M51.878,53.961v50.1a5.022,5.022,0,0,1-5.02,5.02H5.02A5.022,5.022,0,0,1,0,104.062v-50.1a5.022,5.022,0,0,1,5.02-5.02H46.858a4.956,4.956,0,0,1,5.02,5.02",
    transform: "translate(0 -42.142)",
    fill: "#bf7d5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M35.771,179.751H5.02A5.022,5.022,0,0,1,0,174.731v-43.72c.732,12.028,5.857,37.967,35.771,48.74",
    transform: "translate(0 -112.812)",
    fill: "#aa6256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M80.87,84.852c.418,14.12.418,28.136,0,42.256a4.491,4.491,0,0,1-4.5,4.288H45.2a4.582,4.582,0,0,1-4.5-4.393q-.471-21.023,0-42.046a4.511,4.511,0,0,1,4.5-4.393H76.372A4.491,4.491,0,0,1,80.87,84.852Z",
    transform: "translate(-34.849 -69.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M119.409,7.531v4.707a2.321,2.321,0,0,1-2.3,2.3H95.666a2.321,2.321,0,0,1-2.3-2.3V7.531a2.321,2.321,0,0,1,2.3-2.3H98.49a2.114,2.114,0,0,0,1.883-1.464A4.965,4.965,0,0,1,105.289,0h2.2a5.178,5.178,0,0,1,5.02,3.765,1.888,1.888,0,0,0,1.778,1.464h2.824A2.322,2.322,0,0,1,119.409,7.531Z",
    transform: "translate(-80.395)",
    fill: "#9b422d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M179.118,22.547a1.464,1.464,0,1,1-1.464-1.464,1.5,1.5,0,0,1,1.464,1.464",
    transform: "translate(-151.714 -18.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M14.181,180.416a74.444,74.444,0,0,0,.628-10.773,75.313,75.313,0,0,0-.628-10.773,74.445,74.445,0,0,0-.628,10.773,74.444,74.444,0,0,0,.628,10.773",
    transform: "translate(-11.67 -136.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M207.812,88.512a18.012,18.012,0,0,0,4.079.418,18.634,18.634,0,0,0,4.079-.418,17.417,17.417,0,0,0-4.079-.418,18.012,18.012,0,0,0-4.079.418",
    transform: "translate(-178.944 -75.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M88.431,152.368a7.639,7.639,0,0,1-10.878,0l5.439-5.439v0Z",
    transform: "translate(-66.78 -119.944)",
    fill: "#f34b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M63.452,140.842a7.779,7.779,0,0,1,5.439-2.3v7.635l-5.439,5.543a7.639,7.639,0,0,1,0-10.878",
    transform: "translate(-52.679 -119.296)",
    fill: "#fe911f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M124.341,146.929a7.673,7.673,0,0,1-2.2,5.439l-5.439-5.439v-7.635A7.61,7.61,0,0,1,124.341,146.929Z",
    transform: "translate(-100.494 -119.944)",
    fill: "#ffd06c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M211.808,147.66a.9.9,0,0,0-.837-.837H198.107a.9.9,0,0,0-.837.837.825.825,0,0,0,.837.837h12.865a.77.77,0,0,0,.837-.837",
    transform: "translate(-169.867 -126.427)",
    fill: "#f26f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M211.808,180.79a.9.9,0,0,0-.837-.837H198.107a.9.9,0,0,0-.837.837.825.825,0,0,0,.837.837h12.865a.77.77,0,0,0,.837-.837",
    transform: "translate(-169.867 -154.955)",
    fill: "#f26f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M211.808,213.919a.9.9,0,0,0-.837-.837H198.107a.9.9,0,0,0-.837.837.825.825,0,0,0,.837.837h12.865a.77.77,0,0,0,.837-.837",
    transform: "translate(-169.867 -183.482)",
    fill: "#f26f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M211.808,247.048a.9.9,0,0,0-.837-.837H198.107a.9.9,0,0,0-.837.837.825.825,0,0,0,.837.837h12.865a.825.825,0,0,0,.837-.837",
    transform: "translate(-169.867 -212.009)",
    fill: "#f26f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M206.683,279.425a.9.9,0,0,0-.837-.837h-7.74a.9.9,0,0,0-.837.837.825.825,0,0,0,.837.837h7.74c.418.1.837-.314.837-.837",
    transform: "translate(-169.867 -239.889)",
    fill: "#f26f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M78.662,276.079a1.384,1.384,0,0,1-1.36,1.36,1.3,1.3,0,0,1-1.255-1.36,1.272,1.272,0,0,1,1.255-1.255,1.238,1.238,0,0,1,1.36,1.255",
    transform: "translate(-65.483 -236.647)",
    fill: "#fe911f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M110.285,276.079a1.384,1.384,0,0,1-1.36,1.36,1.3,1.3,0,0,1-1.255-1.36,1.272,1.272,0,0,1,1.255-1.255,1.3,1.3,0,0,1,1.36,1.255",
    transform: "translate(-92.713 -236.647)",
    fill: "#f34b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M141.156,276.079a1.384,1.384,0,0,1-1.36,1.36,1.3,1.3,0,0,1-1.255-1.36,1.272,1.272,0,0,1,1.255-1.255,1.3,1.3,0,0,1,1.36,1.255",
    transform: "translate(-119.296 -236.647)",
    fill: "#ffd06c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M74,346.332v7.74a.715.715,0,0,1-.732.732h-2.51a.715.715,0,0,1-.732-.732v-7.74a.715.715,0,0,1,.732-.732h2.51a.715.715,0,0,1,.732.732",
    transform: "translate(-60.296 -297.592)",
    fill: "#f34b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M125.2,315.461v12.133a.715.715,0,0,1-.732.732h-2.51a.715.715,0,0,1-.732-.732V315.461a.715.715,0,0,1,.732-.732h2.51a.715.715,0,0,1,.732.732",
    transform: "translate(-104.384 -271.009)",
    fill: "#fe911f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M176.4,362.143v5.648a.715.715,0,0,1-.732.732h-2.51a.715.715,0,0,1-.732-.732v-5.648a.715.715,0,0,1,.732-.732h2.51a.715.715,0,0,1,.732.732",
    transform: "translate(-148.471 -311.206)",
    fill: "#e73729"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 3.975,
    height: 10.25,
    rx: 1.987,
    transform: "translate(31.064 47.067)",
    fill: "#ffd06c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M278.8,379.461V382.6a.715.715,0,0,1-.732.732h-2.51a.715.715,0,0,1-.732-.732v-3.138a.715.715,0,0,1,.732-.732h2.51a.715.715,0,0,1,.732.732",
    transform: "translate(-236.647 -326.119)",
    fill: "#fdbd86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M441.705,425.412,443.693,432a1.027,1.027,0,1,1-1.987.523l-1.987-6.589Z",
    transform: "translate(-378.636 -366.317)",
    fill: "#9b422d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M392.157,302.692l4.6,15.375a4.365,4.365,0,0,1-2.929,5.439,4.627,4.627,0,0,1-3.347-.314,4.4,4.4,0,0,1-2.092-2.615l-4.6-15.375c-.628-2.2,7.635-4.707,8.367-2.51",
    transform: "translate(-330.447 -259.913)",
    fill: "#f34b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M392.157,302.692l.941,3.242c-1.569,1.673-6.066,3.033-8.367,2.51l-.941-3.242c-.628-2.2,7.635-4.707,8.367-2.51",
    transform: "translate(-330.447 -259.913)",
    fill: "#e11226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M348.162,155.651l5.543,18.513c.837,2.615-9.2,5.648-10.041,3.033l-5.543-18.513a5.245,5.245,0,0,1,10.041-3.033Z",
    transform: "translate(-290.949 -130.862)",
    fill: "#ffd06c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M344.62,169.332a3.544,3.544,0,0,1,4.393,2.406l3.242,10.982a1.027,1.027,0,1,1-1.987.523l-3.242-10.669a1.724,1.724,0,0,0-2.2-1.15l-10.146,3.033a.929.929,0,0,1-1.255-.732,1.076,1.076,0,0,1,.732-1.255Z",
    transform: "translate(-287.094 -145.694)",
    fill: "#9b422d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M451.013,256.32a2.349,2.349,0,1,1-2.929-1.569,2.4,2.4,0,0,1,2.929,1.569",
    transform: "translate(-384.387 -219.294)",
    fill: "#9b422d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M450.346,261a2.483,2.483,0,0,1-1.673,1.987,2.318,2.318,0,0,1-2.929-1.569,2.087,2.087,0,0,1,.732-2.406,2.9,2.9,0,0,0,.1.941,2.4,2.4,0,0,0,2.929,1.569A2.278,2.278,0,0,0,450.346,261Z",
    transform: "translate(-383.72 -223.032)",
    fill: "#674c4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M446.494,346.353a43.188,43.188,0,0,1,1.987,5.439,42.353,42.353,0,0,1,1.255,5.23,33.879,33.879,0,0,1-1.987-5.439A34.394,34.394,0,0,1,446.494,346.353Z",
    transform: "translate(-384.47 -298.24)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportAnalysis);
export default __webpack_public_path__ + "static/media/report-analysis.a1bfbc3082769bfd5205926b11fff213.svg";
export { ForwardRef as ReactComponent };